
import React from 'react'

function SwiperItem ({list, play, pause}) {
    const videoPause = (index) => {
        pause(index)
    }
    const videoPlay = (index) => {
        play(index)
    }
    return (
        list.map((item, index) => {
            return (
                <li className={`lx-flex-row-center ${item.isCurrent?'current':''}${item.isPrev?'prev':''}${item.isNext?'next':''}`} key={index}>
                    {/* <img src={item.url} alt="" /> */}
                    <video 
                        className="video lx-h100"
                        id={`video${index}`}
                        muted
                        controls
                        loop
                        controlsList='nodownload'
                        onPause={ videoPause.bind(this, index) } 
                        onPlay={ videoPlay.bind(this, index) }
                        poster={item.url}
                        src={item.videoSrc}>
                    </video>
                    
                    {/* <div className={`video-cover lx-relative lx-w100 lx-h100 ${item.isShowCover?'': 'hide'} ${item.isCurrent?'current':''}`} style={{backgroundImage: `url('${item.url}')`}}> */}
                        {/* <div className={`prism-big-play-btn`} onClick={ videoPlay.bind(this, index) }>
                            <div className="outter"></div>
                        </div> */}
                    {/* </div> */}
                </li>
            )
        })
    ) 
}

export default SwiperItem;